import React, { useState } from "react";
import PropTypes from "prop-types";

// import components
import { Form, Col } from "react-bootstrap";

// import custom components.
import Filter from "../common/Filter";
import Selecter from "../common/Selecter";

// import data
import {DIPLOMES, STUDIES_LEVELS, SECTORS } from "../../helpers/dummies";

const Searcher = ({ col, history }) => {
  const [data, setData] = useState({});

  const onSelected = (selected, option) => {
    setData({ ...data, [option]: [selected] });
  };

  const onChanged = (e) => {
    if (e.target) {
      let { name, value } = e.target;
      setData({ ...data, [name]: value });
    }
  };

  const onSubmited = (e) => {
    e.preventDefault();
    if (history) {
      history.push({
        pathname: "/searches",
        state: {
          data: data,
        },
      });
    }
  };

//   const onSubmited = (e) => {
//     e.preventDefault();
//     console.log(data, "ON SUBMIT DATA")
// }

  return (
    <div className="container">
      <div className="row justify-content-center">
      <div className={`col-lg-${col}`}>
        {/* <div className={`col-xl-${col} col-lg-12`}> */}
          <Filter
            withShadow
            onSubmited={onSubmited}
            withSubmit
            submitLabel="Rechercher"
            submitCols={{ lg: 2, md: 4, sm: 6 }}
          >
            <Col lg={3} sm={12}>
              <Form.Group className="mb-0">
                <Selecter
                  id="diplomas"
                  name="diplomas"
                  placeholder="Niveau d'étude"
                  selecterClasses="filters-selects"
                  selecterClassesPrefix="filters-selects-prefix"
                  selected={data.diplomas || []}
                  options={DIPLOMES}
                  onSelected={onSelected}
                />
              </Form.Group>
            </Col>
            <Col lg={4} sm={12}>
              <Form.Group className="mb-0">
                <Selecter
                  id="sectors"
                  name="sectors"
                  placeholder="Filière"
                  selecterClasses="filters-selects"
                  selecterClassesPrefix="filters-selects-prefix"
                  selected={data.sectors || []}
                  options={SECTORS}
                  onSelected={onSelected}
                />
              </Form.Group>
            </Col>
            <Col lg={3} sm={12}>
              <Form.Group className="mb-0 h-100">
                <Form.Control
                  type="text"
                  id="location"
                  name="location"
                  className="form-control"
                  placeholder="Ville ou Pays"
                  onChange={onChanged}
                />
              </Form.Group>
            </Col>
          </Filter>
        </div>
      </div>
    </div>
  );
};
Searcher.propTypes = {
  col: PropTypes.number,
};
Searcher.defaultProps = {
  col: 10,
};
export default Searcher;
